import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import EmergencyBannerContainer from '../../containers/emergencyBanner/EmergencyBannerContainer';

const Page = ({ children, outlet }) => (
  <main id="c-page" className="c-page" role="main">
    {outlet === 'US' && <EmergencyBannerContainer />}
    {children}
  </main>
);

Page.propTypes = {
  children: PropTypes.node,
  outlet: PropTypes.string,
};

const mapStateToProps = state => ({
  outlet: state.app.config.outlet,
});

const ConnectedPage = connect(mapStateToProps)(Page);

Page.Main = ({ children }) => <div className="c-page__main">{children}</div>;

ConnectedPage.Main = Page.Main;

Page.Main.propTypes = {
  children: PropTypes.node,
};

export default ConnectedPage;
